import React from "react";

export const SkeletonFormView = () => {
    return (
        <div className="flex flex-col gap-2">
            <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
            <div className="flex items-center gap-2">
                <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
                <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
                <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
            </div>
            <div className="flex items-center gap-2">
                <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
                <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
                <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
            </div>
            <div className="skeleton w-3/4 h-28 rounded-md bg-accent"></div>
            <div className="skeleton w-72 h-4 rounded-md bg-accent"></div>
            <div className="flex items-center gap-2">
                <div className="skeleton w-10 h-10 rounded-md bg-accent"></div>
                <div className="skeleton w-10 h-10 rounded-md bg-accent"></div>
                <div className="skeleton w-10 h-10 rounded-md bg-accent"></div>
                <div className="skeleton w-10 h-10 rounded-md bg-accent"></div>
            </div>
            <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
            <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
        </div>
    )
}